<div class="dl-verbindingsstatus__lampje"
     [class.dl-verbindingsstatus__lampje--verbroken]="!samenwerking.verbonden()"
     [title]="(samenwerking.verbonden() ? 'VERBINDING' : 'GEENVERBINDING') | translate"></div>
